import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToUser,
  type CurrentAccessApiResource,
  type PlatformUser,
  type UpdateCurrentUserProfileInput,
  type UserApiResource,
} from './usersApi.types';

export async function fetchCurrentUser(): Promise<PlatformUser> {
  const response = await httpClient.get<UserApiResource>('/users/me');
  return mapApiResourceToUser(response.data);
}

export async function updateCurrentUserProfile(
  changes: UpdateCurrentUserProfileInput
): Promise<PlatformUser> {
  const body: Record<string, unknown> = {};
  if (changes.fullName !== undefined) {
    body.full_name = changes.fullName;
  }
  if (changes.phone !== undefined) {
    body.phone = changes.phone;
  }
  if (changes.preferredLanguage !== undefined) {
    body.preferred_language = changes.preferredLanguage;
  }
  const response = await httpClient.patch<UserApiResource>('/users/me', body);
  return mapApiResourceToUser(response.data);
}

export async function fetchCurrentUserPlatformPermissions(): Promise<string[]> {
  const response = await httpClient.get<CurrentAccessApiResource>('/me/access');
  return response.data.platform_permissions;
}

export async function fetchPlatformUsers(
  page: number,
  pageSize: number,
  search: string
): Promise<PaginatedResult<PlatformUser>> {
  const trimmedSearch = search.trim();
  const response = await httpClient.get<PaginatedApiResource<UserApiResource>>('/users', {
    params: {
      page,
      page_size: pageSize,
      search: trimmedSearch.length === 0 ? undefined : trimmedSearch,
    },
  });
  return mapPaginatedResource(response.data, mapApiResourceToUser);
}
